import {
  LeadTimeTypeSchema,
  type LeadTimeType as GeneratedLeadTimeType
} from '~/services/api/generated'

// Mirrors backend App\Enums\Store\LeadTimeType

export type LeadTimeType = GeneratedLeadTimeType

export const LeadTimeType = {
  HOURS: LeadTimeTypeSchema.enum.hours,
  SAME_DAY: LeadTimeTypeSchema.enum.same_day,
  DAY_BEFORE: LeadTimeTypeSchema.enum.day_before,
  MULTIPLE_DAYS: LeadTimeTypeSchema.enum.multiple_days
} satisfies Record<string, GeneratedLeadTimeType>

export const LeadTimeTypeValues: readonly GeneratedLeadTimeType[] = [
  LeadTimeTypeSchema.enum.hours,
  LeadTimeTypeSchema.enum.same_day,
  LeadTimeTypeSchema.enum.day_before,
  LeadTimeTypeSchema.enum.multiple_days
]
